import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { Typography } from "@mui/material";
import { ArrowForward as ArrowForwardIcon } from "@mui/icons-material";

export default function Wait() {
  return (
    <Box sx={{ mx: "auto" }}>
      <Typography variant="h5" fontWeight={"bold"} color={"secondary"}>
        {t("notFound.title")}
      </Typography>

      <Button to="/" component={Link} variant="outlined" fullWidth>
        <Typography marginRight={1}>{t("notFound.goToStartAction")}</Typography>
        <ArrowForwardIcon />
      </Button>
    </Box>
  );
}
